// @flow
import React from "react";

import Icon, { type IconProps } from "../";

export default function Person({
  fill = "currentColor",
  width = "16px",
  ...props
}: IconProps) {
  return (
    <Icon
      
      viewBox="0 0 16 16"
      fill={fill}
      width={width}
      {...props}
    >
      <path
        d="M0,370v-2c0-2.2,3.6-4,8-4s8,1.8,8,4v2Zm4-12a4,4,0,1,1,4,4A4,4,0,0,1,4,358Z"
        transform="translate(0 -354)"
      />
    </Icon>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Tournaments/Person.js